module.exports = __webpack_public_path__ + "static/Planet_5-ae9bcc567f6e6e80b6cca52a7b1d6ce8.png";